enum CasaAIModule {
  COPY_WRITE = 'copyWrite',
  GENERATIVE = 'generative',
  CHAT_COMPLETION = 'chatCompletion',
}

export default CasaAIModule;
